app.controller('CheckoutQuoteController', [
	'$scope',
	'Config',
	'$timeout',
	'toaster',
	'CacheFactory',
	'quote',
	'$window',
	'cart',
	'helper',
	'$http',
	'$interval',
	'userJourney',
	function ($scope, Config, $timeout, toaster, CacheFactory, quote, $window, cart, helper, $http, $interval, userJourney) {
		helper.showTransLoader();
		setTimeout(function() {
			helper.hideTransLoader();
		}, 1000);
		$scope.base_url = Config.base_url;
		$scope.discountCode = '';
		$scope.cart = cart.getCart();
		$scope.user_journey = userJourney.getJourney();
		$scope.buyingCart = cart.getBuyingCart();
		$scope._error = '';
		$scope.deliveryDate = '';
		$scope.collectionDate = '';
		$scope.hireWeeks = 1;
		$scope.globalTime = moment().toDate();
		$scope.showPoReference = false;
		$scope.out_of_stock = 0;
		$scope.finishedStockChecks = false;
		$scope.allowFailedStock = true;
		$scope.totals = {
			total_ex_vat: 0,
			vat: 0,
			total_inc_vat: 0,
			discountedTotalExVat: 0,
			discountedTotalIncVat: 0,
			tlif: false
		}
		$scope.CountDown = {
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0,
			getTimeRemaining: function(endtime) {
			  var t = Date.parse(endtime) - Date.parse(new Date());
			  var seconds = Math.floor((t / 1000) % 60);
			  var minutes = Math.floor((t / 1000 / 60) % 60);
			  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
			  var days = Math.floor(t / (1000 * 60 * 60 * 24));
			  return {
				'total': t,
				'days': days,
				'hours': hours,
				'minutes': minutes,
				'seconds': seconds
			  };
			},

			initializeClock: function(endtime) {
				function updateClock() {
									  
				  var t = $scope.CountDown.getTimeRemaining(endtime);
				  
				  var dateDifference = moment($scope.quote.created_on).add($scope.quote.tlif.tlif_min_count, 'm').add($scope.quote.server_date_offset,'milliseconds').diff(new Date);
	
				  $scope.$applyAsync();  
				  $scope.CountDown.days = t.days < 10 ? '0' + t.days : t.days;
				  $scope.CountDown.hours = ('0' + t.hours).slice(-2);
				  $scope.CountDown.minutes = ('0' + t.minutes).slice(-2);
				  $scope.CountDown.seconds = ('0' + t.seconds).slice(-2);

				  if(t.total == 1000){
					  $scope.updateTlifStatus();
				  }
		  
				  if ((t.total <= 0) || ($scope.quote.discountCode)) {
					  $interval.cancel(timeinterval);
					  $scope.quote.tlif.enabled = false;
					  $scope.totals.tlif.enabled = false;
				  } else {
					  if ($scope.quote.tlif.enabled!=true){
						  $scope.quote.tlif.enabled = true;
						  $scope.totals.tlif.enabled = true;
					  }
					  
				  }
				}
		
				updateClock();
				var timeinterval = $interval(updateClock, 1000);
				
			  }
			}

		$scope.getCartQuantityDifference = function (cart, buyCart) {
			if (cart.content.length > buyCart.content.length) {
				$scope.cartQuantityDifference = true;
			} else {
				$scope.cartQuantityDifference = false;
			}
		};

		$scope.init = function () {
			if(angular.isDefined(CacheFactory.get('appCache').get('delivery'))){
				$scope.transport = CacheFactory.get('appCache').get('delivery'); 
			} 
			else {
				$scope.transport = {
					'delivery':{
					  'install':'no',
					  'installCost':0,
					  'option':null,
					  'timeSlots':Config.insideWorkingHours,
					  'timeStart':'08:00',
					  'timeEnd':'18:00',
					  'startReadOnly':true
					},
					'collection':{
					  'derig':'no',
					  'derigCost':0,
					  'option':null,
					  'timeSlots':Config.insideWorkingHours,
					  'timeStart':'08:00',
					  'timeEnd':'18:00',
					  'startReadOnly':true
					}
				  }
			}
	
			if(angular.isDefined(CacheFactory.get('appCache').get('details_transport'))){
				var temp_transport = CacheFactory.get('appCache').get('details_transport');
				$scope.transport.delivery.option = temp_transport.delivery.option;
				$scope.transport.delivery.timeStart = temp_transport.delivery.timeStart;
				$scope.transport.delivery.timeEnd = temp_transport.delivery.timeEnd;
				$scope.transport.delivery.timeSlots = temp_transport.delivery.actual_timeslots;
				$scope.transport.delivery.install = temp_transport.delivery.install;
				$scope.transport.delivery.installCost = temp_transport.delivery.installCost;
	
				$scope.transport.collection.option = temp_transport.collection.option;
				$scope.transport.collection.timeStart = temp_transport.collection.timeStart;
				$scope.transport.collection.timeEnd = temp_transport.collection.timeEnd;
				$scope.transport.collection.timeSlots = temp_transport.collection.actual_timeslots;
				$scope.transport.collection.derig = temp_transport.collection.derig;
				$scope.transport.collection.derigCost = temp_transport.collection.derigCost;

			} 

			//check if it's email quote completion
			if (helper.getParameterByName('quote-id')) {
				$scope.retrieveQuote(helper.getParameterByName('quote-id'));
			} else {
				//check if the quote cache exist otherwise redirect to details page
				if (!angular.isDefined(CacheFactory.get('appCache').get('quote')) || !angular.isDefined(CacheFactory.get('appCache').get('cart')) || $scope.cart.cartChanged == true) {
					$window.location.href = $scope.base_url + 'checkout/details';
				} else {
					$scope.quote = CacheFactory.get('appCache').get('quote');
					if ((typeof $scope.quote.tlif !== 'undefined')&&($scope.quote.tlif)) {
						var deadline = moment($scope.quote.created_on).add($scope.quote.tlif.tlif_min_count, 'm').add($scope.quote.server_date_offset,'milliseconds').toDate();
						
						//caclulating datetime of the end of the countdown
						$scope.CountDown.initializeClock(deadline);
					}
					
					if($scope.quote.quote_limitations == false && stockChecks == true){
						$scope.stockCheck();
					}

					$scope.quote.hasLimitations = { 
						'limitations' :  stockChecks == true ? true : false,
					}
	

					$scope.deliveryDate = moment.unix($scope.quote.deliveryDateTimestamp + ($scope.quote.deliveryDateOffset * 86400)).format("DD/MM/YYYY");
					$scope.collectionDate = moment.unix($scope.quote.collectionDateTimestamp + ($scope.quote.collectionDateOffset * 86400)).format("DD/MM/YYYY");
					$scope.hireWeeks = ($scope.quote.hireDays != 1) ? Math.round(($scope.quote.hireDays / 7) + 0.35) : $scope.quote.hireDays;

					$scope.quote.passedQuoteStage = false;
					$scope.quote.retrievedQuote = false;
					$scope.checkProductsIncart();
					$scope.showBacs();
					$scope.updateTotals();
				}
			}


			if(angular.isDefined($scope.quote) && angular.isDefined($scope.quote.cart)) {
				carbon_check = $scope.quote.cart;
				// console.log($scope)
	
				var co2_qty_net_total = 0;
				var co2_qty_total = 0;
				var carbon = false;
				for(var i=0; i<carbon_check.length; i++){
					if(carbon_check[i].data.carbon != undefined){
						co2_qty_net_total += parseFloat(carbon_check[i].qty * $scope.quote.hireDays * carbon_check[i].data.carbon[0].co2_net_item).toFixed(3); //set the string to int and calculate
						co2_qty_total += parseFloat(carbon_check[i].qty * carbon_check[i].data.carbon[0].co2_total ).toFixed(3);
						carbon = true;
					}
				}
	
				if(carbon == true){ 
					$scope.quote['carbon_footprint'] = {
						'co2_qty_net_total': co2_qty_net_total,
						'co2_qty_total': co2_qty_total,
					};
				}
				CacheFactory.get('appCache').put('quote', $scope.quote);
			}

			if ($(window).width() > 650) {
				$('.collapse').collapse();
			}
			setTimeout(function () {
				// console.log($scope);
			}, 5000);

		}

		$scope.nextStage = function() {
			if($scope.quote.hasLimitations.limitations == true) { return }
			else if($scope.quote.hasLimitations.limitations == false && $scope.quote.quote_limitations == false && $scope.finishedStockChecks == true){
				$scope.quote.passedQuoteStage = true; CacheFactory.get('appCache').put('quote',$scope.quote);
				$window.location.href = $scope.base_url+'checkout/delivery';
			 };
		}

		$scope.continue = function () {
			helper.showTransLoader();
			$window.location.href = $scope.base_url + 'checkout/delivery';
		}

		$scope.downloadPdf = function () {
			//delete kylekatarnls in the vendor folder
			//then execute composer update --prefer-source 
			//finally execute composer dump-autoload
			$window.location.href = $scope.base_url + 'checkout/download-quote-pdf/' + $scope.quote.webQuoteID;
		}

		$scope.print = function () {
			window.print();
		}

		$scope.autoDiscount = function (code) {
			//reset error
			$scope._error = '';

			helper.showTransLoader();

			data = {
				'brand': Config.brand_key,
				'discount-code': code,
				'total-ex-vat': $scope.quote.totalExVat,
				'cart': $scope.cart.content,
				'hire-days': $scope.quote.hireDays,
				'quote-id': $scope.quote.webQuoteID
			};
			if ($scope.quote.buy_option == 'no') {
				quote.validateApplyDiscount(data).then(function (response) {

					//change totals to reflect change
					$scope.quote.discountedTotalExVat = response.data.totalExVat;
					$scope.quote.discountedVat = response.data.vat;
					$scope.quote.discountedTotalIncVat = response.data.totalIncVat;
					$scope.quote.discountCode = response.data.discountCode;
					$scope.quote.discountValue = response.data.discountValue;

					$scope.updateTotals();

					//update cache
					CacheFactory.get('appCache').put('quote', $scope.quote);

					//display top notification
					toaster.pop('success', "Quote Updated!", 'Discount code Applied');

					//remove loader
					helper.hideTransLoader();

				}, function (response) {
					if (response.status == 406) {
						//then there are some limitations
						$scope._error = response.data.error;
						helper.hideTransLoader();
					}
				});

			} else if ($scope.quote.buy_option=='yes') {
				quote.validateApplyBuyDiscount(data).then(function (response) {

					//change totals to reflect change
					$scope.quote.discountedTotalExVat = response.data.totalExVat;
					$scope.quote.discountedVat = response.data.vat;
					$scope.quote.discountedTotalIncVat = response.data.totalIncVat;
					$scope.quote.discountCode = response.data.discountCode;
					$scope.quote.discountValue = response.data.discountValue;

					$scope.updateTotals();

					//update cache
					CacheFactory.get('appCache').put('quote', $scope.quote);

					//display top notification
					toaster.pop('success', "Quote Updated!", 'Discount code Applied');

					//remove loader
					helper.hideTransLoader();

				}, function (response) {
					if (response.status == 406) {
						//then there are some limitations
						$scope._error = response.data.error;
						helper.hideTransLoader();
					}
				});
			}
		}

		$scope.applyDiscount = function (form) {
			//reset error
			$scope._error = '';

			if (form.$valid) {
				helper.showTransLoader();


				data = {
					'brand': Config.brand_key,
					'discount-code': $scope.discountCode.toUpperCase(),
					'total-ex-vat': $scope.quote.totalExVat,
					'cart': $scope.cart.content,
					'hire-days': $scope.quote.hireDays,
					'quote-id': $scope.quote.webQuoteID
				};

				if ($scope.quote.buy_option == 'no') {
					quote.validateApplyDiscount(data).then(function (response) {

						//change totals to reflect change
						$scope.quote.discountedTotalExVat = response.data.totalExVat;
						$scope.quote.discountedVat = response.data.vat;
						$scope.quote.discountedTotalIncVat = response.data.totalIncVat;
						$scope.quote.discountCode = response.data.discountCode;
						$scope.quote.discountValue = response.data.discountValue;

						$scope.updateTotals();
						
						//update cache
						CacheFactory.get('appCache').put('quote', $scope.quote);

						//clear discount code input
						form.$setPristine();
						$scope.discountCode = '';
						form.$setUntouched();

						//display top notification
						toaster.pop('success', "Quote Updated!", 'Discount code Applied');

						//remove loader
						helper.hideTransLoader();

					}, function (response) {
						if (response.status == 406) {
							//then there are some limitations
							$scope._error = response.data.error;
							helper.hideTransLoader();
						}
					});

				} else if ($scope.quote.buy_option=='yes'){
					quote.validateApplyBuyDiscount(data).then(function (response) {

						//change totals to reflect change
						$scope.quote.discountedTotalExVat = response.data.totalExVat;
						$scope.quote.discountedVat = response.data.vat;
						$scope.quote.discountedTotalIncVat = response.data.totalIncVat;
						$scope.quote.discountCode = response.data.discountCode;
						$scope.quote.discountValue = response.data.discountValue;
						$scope.updateTotals();
						//update cache
						CacheFactory.get('appCache').put('quote', $scope.quote);

						//clear discount code input
						form.$setPristine();
						$scope.discountCode = '';
						form.$setUntouched();

						//display top notification
						toaster.pop('success', "Quote Updated!", 'Discount code Applied');

						//remove loader
						helper.hideTransLoader();

					}, function (response) {
						if (response.status == 406) {
							//then there are some limitations
							$scope._error = response.data.error;
							helper.hideTransLoader();
						}
					});
				}
			}
		}

		$scope.stockCheck = function() {
			var limitations = [];
			var hasLimitations = false;
			$scope.checkingLimitations = true;

			$scope.checkStockIteration(0, limitations, hasLimitations);

			$scope.quote.cart.forEach(function(item, index) { 
				

			})

			$(document).on("click", ".show_product_alternatives", function(e) {
				var target = $(this);
				$scope.handleModal(e, target);
				$('#alternative_products_modal').modal('show');
			});

						
			$(document).on("click", ".add_alternative", function(e) {
				var details = $(this);
				var curr_cart_index = details.attr("data-cart-index");
				$scope.addAlternativeItem(details, curr_cart_index)
			});

		}

		$scope.checkStockIteration = function(index, limitations, hasLimitations){
			var item = $scope.quote.cart[index];
			var queryData = {
				postcode: $scope.quote.deliveryPostcode,
				totalExVat: $scope.quote.totalExVat,
				hireDays: $scope.quote.hireDays,
				deliveryDateTimestamp: $scope.quote.deliveryDateTimestamp,
				collectionDateTimestamp: $scope.quote.collectionDateTimestamp,
				item: item,
				index: index,
				webquote: $scope.quote
			}

			quote.checkStock(queryData).then(function(response) {

				if($scope.allowFailedStock == false){
					quote.getProductAlternatives(item.data, Config.brand_key).then(function(alternativeResponse) { //$scope.quote.brand
						$scope.quote.cart[index].data.alternatives = alternativeResponse.data;
						$scope.cart.content[index].data.alternatives = alternativeResponse.data;
						handleCartItem()
					})
				}
				else {
					handleCartItem()
				}

				function handleCartItem(){

				
					const availabilityClass = $('#div-availability-'+index)
					const spinner = $('#spinner-'+index);
					const span = $("#span-"+index);
					$scope.quote.cart[index].data.limitation_message = '';

					if(response.data.limitations == true){
						if(hasLimitations == false){
							limitations = response.data
							hasLimitations = true;
						}
						$scope.quote.cart[index].data.limitation_message = 'Not in stock';
						$scope.quote.cart[index].available = false;
						$scope.cart.content[index].available = false;
						$scope.updateStockCounts('stock');
						$(availabilityClass).append('<div class="quote-icons" style="display: inline-flex; background-color: #f32222c9; float: left; margin-left: 8px;"><i style="color: #fff; margin-left: auto; margin-right: auto; position: unset; display:block;" class="fa fa-close"></i></div>');

					}
					else {
						$(availabilityClass).append('<div class="quote-icons" style="display: inline-flex; background-color: #a4d605; float: left; margin-left: 8px;"><i style="color: #fff; margin-left: auto; margin-right: auto; position: unset; display:block;" class="fa fa-check"></i></div>');
						$scope.quote.cart[index].data.limitation_message = 'In stock';
						$scope.quote.cart[index].available = true;
						$scope.cart.content[index].available = true;

					}
					$(span).html($scope.quote.cart[index].data.limitation_message);
					$(spinner).addClass('hidden');

					var availability_default = document.querySelectorAll(".availability_default");
					availability_default.forEach(function(item) {
						item.style.display = 'none';
	
					})


					if(index == $scope.quote.cart.length - 1){ //checking if we are in the last iteration in the loop
						if(hasLimitations == false){
							$scope.setEnabled();
						}
						else {
							if($scope.allowFailedStock == false){
								$scope.quote.quote_limitations = limitations; //limitations is the json response returned from the ajax
								$scope.quote.hasLimitations.limitations = true;
							}
							
							try {
								// CacheFactory.get("appCache").put("quote", $scope.quote);
									
									//the next step is to send an email to staff if required
									quote.sendStockCheckEmail($scope.quote.cart, $scope.quote)

									if($scope.allowFailedStock == true){
										$scope.setEnabled();
									}
								
							} catch (error) {
								// console.log(error)
							}
						}
						$scope.finishedStockChecks = true;

					}
					else {
						return $scope.checkStockIteration(index+1, limitations, hasLimitations);
					}

				}
			})
		}

		$scope.setEnabled = function() {
			$scope.quote.hasLimitations.limitations = false;
			$('.quote_button').attr('disabled', false)
		}

		$scope.handleModal = function(e, target) {
			var cart_index = target.attr("data-index");
			var modal = $('.alternative_wrapper');
			var alternatives = $scope.quote.cart[cart_index].data.alternatives
			modal.empty();

			$('#alternative_tag').text('We are loading some products... please be patient.');
			var progressbar = $( "#progressbar" );
			// var progressbarValue = progressbar.find( ".ui-progressbar-value" );
			progressbar.show();
			progressbar.progressbar({
				value: 0,
				change: function() {
					$( ".progress-label" ).text('100%')
				}
			});

			var alternative_count = 0;
			var qty = $scope.quote.cart[cart_index].qty;
			var index = 0;


			if(alternatives.length != 0){
				alternatives[index].qty = qty;
			}

			$scope.quote.cart.forEach(function(item, index) { 
				alternatives.forEach(function(alt, idx) {
					if(alt.data.product_code == item.data.product_code){
						alt.qty = parseInt(qty) + parseInt(item.qty);
					}
				})
			})

			var data = "";
				data += '</tbody></table>';
				data += '<table class="table_type_2 w_full t_align_l" style="" id="added_to_cart_col_table"><thead><tr class="bg_light_2 color_dark">';
				data += '<th>Image</th><th>Name</th><th>Code</th><th class="text-right">Price</th><th style="width: 10%">Action</th></tr></thead><tbody id="alternative_body">';

			function loop(){
				
				if((alternative_count == 3) || (index == alternatives.length && alternative_count > 0)){
					$('#alternative_tag').text('Please choose an alternative product to continue')
					modal.append(data);
					progressbar.progressbar({
						value: 100
					});
					$('#progressbar').hide();
					return;
				}
				if(index == alternatives.length){
					$('#alternative_tag').text('Sorry! No alternative products are available at this time.');
					$('#progressbar').hide();
					return;
				}

				if(!alternatives[index].qty){
					alternatives[index].qty = qty;
				}

				var api_data = {
					postcode: $scope.quote.deliveryPostcode,
					totalExVat: $scope.quote.totalExVat,
					hireDays: $scope.quote.hireDays,
					deliveryDateTimestamp: $scope.quote.deliveryDateTimestamp,
					collectionDateTimestamp: $scope.quote.collectionDateTimestamp,
					item: alternatives[index],
					index: index,
					webquote: $scope.quote
				}


				quote.checkStock(api_data, alternatives, index).then(function(response){
					if(response.data.limitations != true){
						quote.priceBreaksCheck(alternatives[index].data, $scope.quote.brand, alternatives[index].qty, index).then(function(priceResponse){
							var responseIndex = priceResponse.config.data.index;
							if(priceResponse.data.product.price_breaks){
								alternatives[responseIndex].data.product_price = priceResponse.data.product.price_breaks.price;
							}
							else if(priceResponse.data.product.updated){
								alternatives[responseIndex].data.product_price = priceResponse.data.product.price;
							}

							data += '<tr class="tr_delay cart_row">'
							data += '<td><a href="'+Config.base_url+ 'product/' + alternatives[responseIndex].data.product_slug +'" class="r_corners d_inline_b wrapper"><img src="'+alternatives[responseIndex].data.image+'" alt="'+alternatives[responseIndex].data.product_name+'"</a></td>';
							data += '<td>'+alternatives[responseIndex].data.product_name+'</td>';
							data += '<td>'+alternatives[responseIndex].data.product_code+'</td=>';
							data += '<td class="text-right">&pound;'+alternatives[responseIndex].data.product_price+'</td>';
							data += '<td class="text-right"><input data-cart-index="'+ cart_index +'" data-index="'+responseIndex+'" data-product-name="'+alternatives[responseIndex].data.product_name+'" data-product-code="'+alternatives[responseIndex].data.product_code+'" data-price="'+alternatives[responseIndex].data.product_price+'" class="add_alternative btn btn-xs btn-success pull_right" type="button" value="Add"/></td>';
							data += '</tr>';
							alternative_count++;
						})
						
					}
					var progressbarValue = progressbar.find( ".ui-progressbar-value" );
					$( "#progressbar" ).progressbar({
						value: Math.floor((index/alternatives.length)*100),
						change: function() {
							$( ".progress-label" ).text(Math.floor((index/alternatives.length)*100) + '%')
						}
					});
					progressbarValue.css({
						background: '#a4d605',
					})
					index++;
					setTimeout(function(){

						

						loop()
					}, 1000)
				})
			}
			loop()

		}

		$scope.closeModal = function() {
			$('#alternative_products_modal').modal('hide');
		}

	$scope.removeProduct = function(index) {
		helper.showTransLoader();
		var cart_lengths = {
			quote: $scope.quote.cart.length,
			cart: $scope.cart.content.length,
		}
		var dateStringDel = $scope.deliveryDate.toString();
		var datePartsDel = dateStringDel.split("/");
		var dateObjectDel = new Date(+datePartsDel[2], datePartsDel[1] - 1, +datePartsDel[0]); 

		var dateStringCol = $scope.collectionDate.toString();
		var datePartsCol = dateStringCol.split("/");
		var dateObjectCol = new Date(+datePartsCol[2], datePartsCol[1] - 1, +datePartsCol[0]); 


		var unixDel = moment(dateObjectDel).endOf('day').unix()
		var unixCol = moment(dateObjectCol).endOf('day').unix()

		$scope.cart.content.forEach(function(item, cart_index) {
			if(cart_index == index){
				$scope.cart.content.splice(cart_index, 1)
				$scope.quote.cart.splice(cart_index, 1)
				return;
			}
		})

		var total = 0;

		// $scope.quote.quote_limitations = false;
		$scope.cart.content.map(function(item) {
			total = parseFloat(total)+parseFloat(item.subtotal);
		})
		$scope.quote.productTotal = total;
		$scope.quote.productTotalFinal = total;

		setTimeout(function() {
			cart.updateCart('checkout', true);
			$scope.quote.cartTotalWeight = cart.totalWeight()
			transportCostData = {
				deliveryPostcode : $scope.quote.deliveryPostcode,
				collectionPostcode : $scope.quote.collectionPostcode,
				cartTotalWeight : $scope.quote.cartTotalWeight,
				delTimestamp : $scope.quote.deliveryDateTimestamp,
				colTimestamp : $scope.quote.collectionDateTimestamp,
			}

			quote.getModifiers(transportCostData).then(function(response) {
				
				$scope.quote.transport = response.data
				$scope.cart.cartChanged = false;
				CacheFactory.get('appCache').put('quote',$scope.quote);
				CacheFactory.get('appCache').put('cart',$scope.cart);
				// var updated_cart = CacheFactory.get('appCache').get('cart');
				var journey_data = null
				$http({
					method: 'POST',
					data: {data: $scope.user_journey},
					url: Config.base_url+'contact/save_journey_and_source'
					}).then(function(journey_res) {

					if(journey_res.data.status=="success"){
						var journey_and_source = journey_res.data.data;
						journey_data = {
							'user-journey-id':journey_and_source.user_journey_id,
							'came-from':journey_and_source.camefrom,
							'utm-campaign':journey_and_source.utm_campaign,
							'utm-medium':journey_and_source.utm_medium,
							'utm-source':journey_and_source.utm_source
						}


					data = {
						'brand': Config.brand_key,
						'delivery-postcode': $scope.quote.deliveryPostcode.toUpperCase(),
						'collection-postcode': $scope.quote.collectionPostcode.toUpperCase(),
						'cart-total-weight': $scope.quote.cartTotalWeight,
						'product-total': $scope.quote.productTotal,
						'company': $scope.quote.company,
						'name': $scope.quote.name,
						'email': $scope.quote.email,
						'telephone': $scope.quote.telephone,
						'hire-days': $scope.quote.hireDays,
						'user-agent': angular.element('#user-agent').val(),
						'user-ip': angular.element('#ip').val(),
						'token': angular.element('#user_token').val(),
						'delivery-date-timestamp': unixDel,
						'collection-date-timestamp': unixCol,
						'cart': CacheFactory.get('appCache').get('cart').content,
						'delivery-date-offset': $scope.quote.deliveryDateOffset,
						'collection-date-offset': $scope.quote.collectionDateOffset,
						'retrieved-quote' : $scope.quote.retrievedQuote,
						'user-journey' : journey_data
					}

					if(cart_lengths.quote != 1 && cart_lengths.cart != 1){
						quote.saveSession(data).then(function (response) {
							//get the delivery and collection timestamps
							quote.get(data).then(function (response) {
								// location.reload()
								$scope.quote = response.data;
								CacheFactory.get('appCache').put('quote', response.data);
								// $scope.cart = updated_cart;
								
								$scope.checkProductsIncart();
								$window.location.href = $scope.base_url+'checkout/quote';
							})
						})
					}
					else {
						CacheFactory.get('appCache').put('quote',$scope.quote);
						CacheFactory.get('appCache').put('cart',$scope.cart);
						$window.location.href = $scope.base_url+'checkout/details';
					}
				}})

			});

		}, 200)
	}

		
	$scope.addAlternativeItem = function(details, cart_index) {
		helper.showTransLoader();
		details.attr('disabled', true);
		var alternative_index = details.attr("data-index");
		var alternative_buttons = document.querySelectorAll(".add_alternative");
		var updated = false;

		var dateStringDel = $scope.deliveryDate.toString();
		var datePartsDel = dateStringDel.split("/");
		var dateObjectDel = new Date(+datePartsDel[2], datePartsDel[1] - 1, +datePartsDel[0]); 

		var dateStringCol = $scope.collectionDate.toString();
		var datePartsCol = dateStringCol.split("/");
		var dateObjectCol = new Date(+datePartsCol[2], datePartsCol[1] - 1, +datePartsCol[0]); 


		var unixDel = moment(dateObjectDel).endOf('day').unix()
		var unixCol = moment(dateObjectCol).endOf('day').unix()

		// $('#alternative_products_modal').modal('hide');

		alternative_buttons.forEach(function(ele) {
            $(ele).attr('disabled', true);
            $(ele).addClass('btn btn-disabled');
        })


		$(details).css('background-color', '#c3b9b9');
		var product_details = {
			product_name : details.attr("data-product-name"),
			product_code : details.attr("data-product-code"),
			index : details.attr("data-index"),
			price : details.attr("data-price"),
			qty: $scope.quote.cart[cart_index].data.alternatives[alternative_index].qty
		}

		$scope.cart.content.forEach(function(item, index) {
			if($scope.quote.cart[cart_index] && item.data.product_code == $scope.quote.cart[cart_index].data.alternatives[alternative_index].data.product_code){
				item.qty = product_details.qty
				item.subtotal = ((product_details.qty) * (product_details.price)) * $scope.hireWeeks
				$scope.quote.cart[index].qty = item.qty
				$scope.quote.cart[index].subtotal = item.subtotal
				$scope.cart.content.splice(cart_index, 1)
				$scope.quote.cart.splice(cart_index, 1)
				updated = true;
				return;
			}
		})

		if(updated == false){
			var cartItem = $scope.quote.cart[cart_index].data.alternatives[product_details.index];
			cartItem.available = true;
			cartItem.bow =   $scope.quote.cart[cart_index].data.alternatives[product_details.index].data.bow_color_option == 'yes' ? 'yes' : null,
			cartItem.pad =  $scope.quote.cart[cart_index].data.alternatives[product_details.index].data.pad_color_option == 'yes' ? 'yes' : null,
			cartItem.color =  $scope.quote.cart[cart_index].data.alternatives[product_details.index].data.pad_color_option == 'no' ? null : 'Cream' ,
			cartItem.id =  $scope.quote.cart[cart_index].data.alternatives[product_details.index].data.product_id,
			cartItem.price =   product_details.price
			cartItem.subtotal =  ((product_details.qty) * (parseFloat(product_details.price))) * $scope.hireWeeks,

			$scope.quote.cart[cart_index] = cartItem;
		}



		var orginal_cart = CacheFactory.get('appCache').get('cart');
		var total = 0;

		// $scope.quote.quote_limitations = false;
		orginal_cart.content = $scope.quote.cart;
		orginal_cart.content.map(function(item) {
			total = parseFloat(total)+parseFloat(item.subtotal);
		})
		$scope.quote.productTotal = total;
		$scope.quote.productTotalFinal = total;

		CacheFactory.get('appCache').put('quote',$scope.quote);
		CacheFactory.get('appCache').put('cart',orginal_cart);

		$scope.cart = CacheFactory.get('appCache').get('cart');

		
		setTimeout(function() {
			cart.updateCart('checkout', true);
			$scope.quote.cartTotalWeight = cart.totalWeight()
			transportCostData = {
				deliveryPostcode : $scope.quote.deliveryPostcode,
				collectionPostcode : $scope.quote.collectionPostcode,
				cartTotalWeight : $scope.quote.cartTotalWeight,
				delTimestamp : $scope.quote.deliveryDateTimestamp,
				colTimestamp : $scope.quote.collectionDateTimestamp,
			}

			quote.getModifiers(transportCostData).then(function(response) {
				var journey_data = null;

				        
				$http({
					method: 'POST',
					data: {data: $scope.user_journey},
					url: Config.base_url+'contact/save_journey_and_source'
					}).then(function(journey_res) {

					if(journey_res.data.status=="success"){
						var journey_and_source = journey_res.data.data;
						journey_data = {
							'user-journey-id':journey_and_source.user_journey_id,
							'came-from':journey_and_source.camefrom,
							'utm-campaign':journey_and_source.utm_campaign,
							'utm-medium':journey_and_source.utm_medium,
							'utm-source':journey_and_source.utm_source
						}

					
					$scope.quote.transport = response.data
					$scope.cart.cartChanged = false;
					CacheFactory.get('appCache').put('quote',$scope.quote);
					CacheFactory.get('appCache').put('cart',orginal_cart);
					$scope.cart = CacheFactory.get('appCache').get('cart');
					data = {
						'brand': Config.brand_key,
						'delivery-postcode': $scope.quote.deliveryPostcode.toUpperCase(),
						'collection-postcode': $scope.quote.collectionPostcode.toUpperCase(),
						'cart-total-weight': $scope.quote.cartTotalWeight,
						'product-total': $scope.quote.productTotal,
						'company': $scope.quote.company,
						'name': $scope.quote.name,
						'email': $scope.quote.email,
						'telephone': $scope.quote.telephone,
						'hire-days': $scope.quote.hireDays,
						'user-agent': angular.element('#user-agent').val(),
						'user-ip': angular.element('#ip').val(),
						'token': angular.element('#user_token').val(),
						'delivery-date-timestamp': unixDel,
						'collection-date-timestamp': unixCol,
						'cart': CacheFactory.get('appCache').get('cart').content,
						'delivery-date-offset': $scope.quote.deliveryDateOffset,
						'collection-date-offset': $scope.quote.collectionDateOffset,
						'retrieved-quote' : $scope.quote.retrievedQuote,
						'user-journey' : journey_data
				
					}
					quote.saveSession(data).then(function (response) {
						//get the delivery and collection timestamps
						quote.get(data).then(function (response) {

							// location.reload()
							$scope.quote = response.data;
							CacheFactory.get('appCache').put('quote', response.data);
							// $scope.cart = updated_cart;
							if(updated == false){
								$('#alternative-'+cart_index).remove();
								
								const availabilityClass = $('#col-availability-'+cart_index)
								const iconDiv = $('#availability-icon-div-'+cart_index)
								const span = $("#span-"+cart_index);
		
		
								$(iconDiv).remove();
								$(availabilityClass).append('<div class="quote-icons" style="display: inline-flex; background-color: #a4d605; float: left; margin-left: 8px;"><i style="color: #fff; margin-left: auto; margin-right: auto; position: unset; display:block;" class="fa fa-check"></i></div>');
								$scope.quote.cart[cart_index].available = true;
								$scope.cart.content[cart_index].available = true;
		
								$scope.quote.cart[cart_index].data.limitation_message = 'In stock';
								$(span).html($scope.quote.cart[cart_index].data.limitation_message);
							}
							//location.reload()
							
							$window.location.href = $scope.base_url+'checkout/quote';
							// CacheFactory.get('appCache').put('cart',$scope.cart);
						})
					})
				}})
			});
		}, 200)
	}
			
		$scope.updateStockCounts = function(type){
			if(type == 'stock'){
				$scope.out_of_stock += 1;
			}
			if($scope.out_of_stock == 0){
				$scope.quote.hasLimitations = false;
				$scope.quote.quote_limitations = false;
			}
		}

			
		$scope.showBacs = function(){
			var endDate = moment.unix($scope.quote.deliveryDateTimestamp+ ($scope.quote.deliveryDateOffset*86400)).toDate();
			var startDate = moment().toDate();
			var result = -1;
			var currentDate = startDate;
		
			//At least 3 working days away for bacs
			while (currentDate <= endDate)  {  
				var weekDay = currentDate.getDay();
				if(weekDay != 0 && weekDay != 6) 
					result++;
				currentDate.setDate(currentDate.getDate()+1); 
			}
		
			if(result >= 3 && $scope.quote.company != ''){
				$scope.showPoReference = true;
			}
			else {
				$scope.showPoReference = false;
			}
		}

		$scope.retrieveQuote = function (quoteID) {
			//check if the quote is valid and not expired
			helper.showTransLoader();
			quote.retrieveQuote(quoteID, helper.getParameterByName('token')).then(function (response) {

				//if valid then retrive it
				if (helper.getParameterByName('token') != $('#user_token').val()) {
					location.reload();
				} else {
					//clear JS session & add quote to the session
					cart.content = [];
					CacheFactory.get('appCache').removeAll();
					var quoteRes = response.data;

					//set quote data
					$scope.quote = quoteRes;
					if (typeof $scope.quote['buy_option']=='undefined') {
						$scope.quote.buy_option = 'no';
					}
					if ($scope.quote.buy_option=='yes') {
						$scope.getCartQuantityDifference($scope.cart, $scope.buyingCart);
					}

					$scope.hireWeeks = ($scope.quote.hireDays != 1) ? Math.round(($scope.quote.hireDays / 7) + 0.35) : $scope.quote.hireDays;
					$scope.deliveryDate = moment.unix($scope.quote.deliveryDateTimestamp + ($scope.quote.deliveryDateOffset * 86400)).format("DD/MM/YYYY");
					$scope.collectionDate = moment.unix($scope.quote.collectionDateTimestamp + ($scope.quote.collectionDateOffset * 86400)).format("DD/MM/YYYY");
					//update cache variables
					CacheFactory.get('appCache').put('quote', quoteRes);
					CacheFactory.get('appCache').put('hireDays', $scope.quote.hireDays);
					CacheFactory.get('appCache').put('hireWeeks', $scope.hireWeeks);
					CacheFactory.get('appCache').put('deliveryDate', moment.unix($scope.quote.deliveryDateTimestamp + ($scope.quote.deliveryDateOffset * 86400)).format("YYYY-MM-DD"));
					CacheFactory.get('appCache').put('collectionDate', moment.unix($scope.quote.collectionDateTimestamp + ($scope.quote.collectionDateOffset * 86400)).format("YYYY-MM-DD"));
					cart.setCart(quoteRes.cart);
					CacheFactory.get('appCache').put('retrievedQuote', true);
					//if retrival coming from a remarketing campain then store that a click happened
					if (helper.getParameterByName('utm_term')) {
						quote.updateUtmTerm(helper.getParameterByName('utm_term'), $scope.quote.webQuoteID);
					}

					if(quoteRes.transportOptions.delivery.install !== null){
						$scope.transport.delivery.install = quoteRes.transportOptions.delivery.install;
					}
					if(quoteRes.transportOptions.delivery.installCost !== null){
						$scope.transport.delivery.installCost = quoteRes.transportOptions.delivery.installCost;
					}
					if(quoteRes.transportOptions.delivery.option !== null){
						$scope.transport.delivery.option = quoteRes.transportOptions.delivery.option;
					}
					if(quoteRes.transportOptions.delivery.timeSlots !== null){
						$scope.transport.delivery.timeSlots = quoteRes.transportOptions.delivery.timeSlots;
					}
					if(quoteRes.transportOptions.delivery.timeStart !== null){
						$scope.transport.delivery.timeStart = quoteRes.transportOptions.delivery.timeStart;
					}
					if(quoteRes.transportOptions.delivery.timeEnd !== null){
						$scope.transport.delivery.timeEnd = quoteRes.transportOptions.delivery.timeEnd;
					}
					$scope.transport.delivery.startReadOnly = true;
					
					
					if(quoteRes.transportOptions.collection.derig !== null){
						$scope.transport.collection.derig = quoteRes.transportOptions.collection.derig;
					}
					if(quoteRes.transportOptions.collection.derigCost !== null){
						$scope.transport.collection.derigCost = quoteRes.transportOptions.collection.derigCost;
					}
					if(quoteRes.transportOptions.collection.option !== null){
						$scope.transport.collection.option = quoteRes.transportOptions.collection.option;
					}
					if(quoteRes.transportOptions.collection.timeSlots!== null){
						$scope.transport.collection.timeSlots = quoteRes.transportOptions.collection.timeSlots;
					}
					if(quoteRes.transportOptions.collection.timeStart !== null){
						$scope.transport.collection.timeStart = quoteRes.transportOptions.collection.timeStart;
					}
					if(quoteRes.transportOptions.collection.timeEnd !== null){
						$scope.transport.collection.timeEnd = quoteRes.transportOptions.collection.timeEnd;
					}

					$scope.transport.collection.startReadOnly = true;
					CacheFactory.get('appCache').put('delivery', $scope.transport);
					
					$scope.quote.hasLimitations = { 
						'limitations' :  stockChecks == true ? true : false,
					}
					$scope.quote.passedQuoteStage = false;
					$scope.quote.quote_limitations = false;
					$scope.quote.retrievedQuote = true;
					$scope.checkProductsIncart();
					$scope.showBacs();
					$scope.cart.cartChanged = false;

					if($scope.deliveryDate == $scope.collectionDate){
						CacheFactory.get('appCache').put('details_transport', {
							delivery: {
								timeStart: $scope.transport.delivery.timeStart,
								timeEnd: $scope.transport.delivery.timeEnd
							},
							collection: {
								timeStart: $scope.transport.collection.timeStart,
								timeEnd: $scope.transport.collection.timeEnd
							},
						});
					  }

					
					$http({
						method: 'POST',
						url: Config.api_url+'quote/check-limitations',
						data: {data: CacheFactory.get('appCache').get('quote')},
						headers:{
							'authorization':Config.api_key
						}
					  }).then(function(response) {
						  $scope.quote.quote_limitations = response.data
						  CacheFactory.get('appCache').put('quote', $scope.quote);
						//   $scope.checkLimitations();
						if($scope.quote.quote_limitations == false && stockChecks == true){
							$scope.stockCheck();
							$scope.updateTotals();
						}
					  })
					  
					helper.hideTransLoader();
				}

			}, function (response) {
				if (response.status == 406) {
					//if not then show an error
					$scope.retrievedQuote = response.data;
					alert('Your quote expired. Please add new products to get a quote.');
					$window.location.href = $scope.base_url + 'checkout/details';
					
					helper.hideTransLoader();
				}
			});
		}

		
		$scope.updateTlifStatus = function() {
			data = {
				token: $scope.quote.token,
				webquote_id: $scope.quote.webQuoteID
			}
			quote.updateTlifStatus(data)
		}

		$scope.checkProductsIncart = function() {
			if($scope.quote.cart.length == 0 || $scope.cart.content.length == 0){
				$window.location.href = $scope.base_url+'checkout/details';
			}
			else return;
		}

		
		$scope.updateTotals = function(){
			if (($scope.quote.tlif==null) || (typeof $scope.quote.tlif != 'object')||(typeof $scope.quote.tlif.enabled == 'undefined')){
	  
			  var tlif = {
				  enabled:false
			  };
			  $scope.totals.tlif = tlif;
			}
	  
			setTimeout(function(){
				//check for install and derig and add their cost
	
				$scope.totals.discountValue = $scope.quote.discountValue;
				$scope.totals.totalExVat = $scope.quote.totalExVat;
				$scope.totals.discountedTotalExVat = $scope.quote.discountedTotalExVat;
				$scope.totals.vat = $scope.quote.vat;
				$scope.totals.discountedVat = $scope.quote.discountedVat;
				$scope.totals.discountCode = $scope.quote.discountCode;
				$scope.totals.totalIncVat = $scope.quote.totalIncVat;
				$scope.totals.discountedTotalIncVat = $scope.quote.discountedTotalIncVat;

				totalExVat = parseFloat($scope.quote.totalExVat);
				discountedTotalExVat = parseFloat($scope.quote.discountedTotalExVat);

				var tlif_enabled = $scope?.quote?.tlif?.enabled || false;
			
				if (tlif_enabled){
					var tlifTotalExVat = parseFloat($scope.quote.tlif.totalExVat);
				}
			
				if($scope.transport.delivery.install=='yes'){
					totalExVat += parseFloat($scope.transport.delivery.installCost);
					discountedTotalExVat += parseFloat($scope.transport.delivery.installCost);
					if (tlif_enabled){
						tlifTotalExVat += parseFloat($scope.transport.delivery.installCost);
	  
	  
					}
				}
			
				if($scope.transport.collection.derig=='yes'){
					totalExVat += parseFloat($scope.transport.collection.derigCost);
					discountedTotalExVat += parseFloat($scope.transport.collection.derigCost);
					if (tlif_enabled){
						tlifTotalExVat += parseFloat($scope.transport.collection.derigCost);
	  
	  
					}
				}
				if($scope.transport.delivery.option){
					totalExVat += parseFloat($scope.transport.delivery.option.price);
					discountedTotalExVat += parseFloat($scope.transport.delivery.option.price);
					if (tlif_enabled){
						tlifTotalExVat += parseFloat($scope.transport.delivery.option.price);
	  
	  
					}
				}
				if($scope.transport.collection.option){
					totalExVat += parseFloat($scope.transport.collection.option.price);
					discountedTotalExVat += parseFloat($scope.transport.collection.option.price);
					if (tlif_enabled){
						tlifTotalExVat += parseFloat($scope.transport.collection.option.price);
	  
	  
					}
				}
			
	
				$scope.totals.discountValue = $scope.quote.discountValue;
				$scope.totals.totalExVat = parseFloat(helper.formatMoney(totalExVat));
				$scope.totals.discountedTotalExVat = parseFloat(helper.formatMoney(discountedTotalExVat));
				$scope.totals.vat = helper.formatMoney((totalExVat*Config.vatRate)/100);
				$scope.totals.discountedVat = helper.formatMoney((discountedTotalExVat*Config.vatRate)/100);
				$scope.totals.totalIncVat = helper.formatMoney( parseFloat((totalExVat*Config.vatRate)/100) + parseFloat(totalExVat));
				$scope.totals.discountedTotalIncVat = helper.formatMoney(  parseFloat((discountedTotalExVat*Config.vatRate)/100) + parseFloat(discountedTotalExVat));
	  
				if (tlif_enabled){
					$scope.totals.tlif = {
						...$scope.quote.tlif,
						totalExVat: helper.formatMoney(tlifTotalExVat),
						vat: helper.formatMoney((tlifTotalExVat*Config.vatRate)/100),
						totalIncVat: helper.formatMoney( parseFloat((tlifTotalExVat*Config.vatRate)/100) + parseFloat(tlifTotalExVat))
					};
				}
	  
			},100);
	  
		}

	}
]);